import { FC, useState } from 'react';

import { WeekMatches } from '../components/WeekMatches';
import { useStats } from '../StatsContext';
import styles from '../styles.module.scss';
import { getCurrentWeek, getWeekMatches } from '../utils';

const weekNames = [
  'Week 1',
  'Week 2',
  'Week 3',
  'Week 4',
  'Week 5',
  'Week 6',
  'Week 7',
  'Week 8',
  'Week 9',
  'Week 10',
  'Round 1',
  'Round 2',
  'Finále',
];
export const WeekMatchesTop: FC = () => {
  const {
    parsedWeeks,
    playoff,
    stream: { week: streamWeek },
  } = useStats();

  const [matchWeek, setMatchWeek] = useState(
    weekNames.findIndex(
      (value) =>
        value ===
        ((streamWeek && weekNames.includes(streamWeek) ? streamWeek : undefined) ??
          getCurrentWeek({ ...parsedWeeks, ...playoff })),
    ),
  );
  const [title, { start, end, matches }] = getWeekMatches({ ...parsedWeeks, ...playoff }, weekNames[matchWeek]);

  return (
    <WeekMatches
      title={title}
      start={start}
      end={end}
      matches={matches}
      showDate={!streamWeek}
      matchClassName={styles.match}
      disablePrevious={matchWeek <= 0}
      disableNext={matchWeek >= weekNames.length - 1}
      onWeekChange={(change) => setMatchWeek((currWeek) => currWeek + change)}
      className={styles.weekMatchesTop}
    />
  );
};
